import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IJsonQuerySchema } from '../../repositories/newbuilding-promos/entities/json_query/JsonQuerySchema';
import {
  fetchSearchPromos,
  ISearchPromosResponse,
  ISearchPromosResponse200,
  ISearchPromosResponse400,
} from '../../repositories/newbuilding-promos/v1/search-promos';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { ResponseError } from '../../utils/errors';

export async function resolveSearchPromosPageV1({
  httpApi,
  logger,
  queryString,
  jsonQuery,
  subdomain,
}: {
  httpApi: IHttpApi;
  logger: ILogger;
  queryString?: string;
  jsonQuery?: IJsonQuery;
  subdomain: string;
}): Promise<ISearchPromosResponse> {
  try {
    const response = await fetchSearchPromos<ISearchPromosResponse200, ISearchPromosResponse400>({
      httpApi,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
      parameters: {
        queryString,
        jsonQuery: jsonQuery as IJsonQuerySchema,
        subdomain,
      },
    });

    if (response.statusCode !== 200) {
      const { errors, message } = response.response;

      throw new ResponseError({
        message: message || '',
        domain: 'services.resolveSearchPromosPageV1',
        details: { errors },
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
